import React, {Fragment} from 'react';
import classes from './ModifyEligibilityConfirmation.css';
import Label from '../../UI/Label2/Label2';
import Button from '../../UI/Button/Button';
import { LABEL_SAVE, ELIGIBILITY_CONFIRMATION, MEDICAL_RECORD_NUMBER, CAREADVISORCONNECT } from '../../shared/Constants';
import { getPortalNameForEligibilityScreen } from '../../shared/utility';

const modifyEligibilityConfirmation = (props) => {

    let form = null;
    
    const isSdkPortal = props.selectedPortal.isSdkPortal || props.selectedPortal.isPePortal;

    const displayPropMapping = isSdkPortal ? ELIGIBILITY_CONFIRMATION.sdkDisplayPropMapping: ELIGIBILITY_CONFIRMATION.displayPropMapping;

    if(props.memberInfo && props.selectedPortal && props.updatedFormData) {

        let memberPortalData = props.modifyEligPortal;

        const memberMdmInfo = (
            <div>
                <strong className={classes.Caution}>You're about to modify or add an eligibility record for this member:</strong>
                <br/>
                <Label displayType="horizontal" labelText="Name" labelValue={props.memberInfo.mdmFirstNm+" "+props.memberInfo.mdmLastNm} labelWidth="15%" />
                <Label displayType="horizontal" labelText="DOB" labelValue={props.memberInfo.mdmDob} labelWidth="15%" />
                <Label displayType="horizontal" labelText="Zip" labelValue={props.memberInfo.mdmZip} labelWidth="15%" />
                <strong className={classes.Caution}>Are you sure?</strong>
            </div>);

        let currentPortalEligElems = [], newPortalEligElems=[], displayValue = [];
        let changeInData = false;
        let prevInfoObject = {};
        let objKey;
        let objValue;
        if(!isSdkPortal){
            for (let key in displayPropMapping) {
                // console.log("[ModifyELigConfirmation] selectedPortal valid elems", key, props.selectedPortal.validElems[key]);
                if(props.selectedPortal?.validElems?.[key] && props.selectedPortal?.validElems?.[key]?.isEnabled) {
                    currentPortalEligElems.push(
                        <Label
                            key={"curr"+displayPropMapping[key].label}
                            displayType="horizontal"
                            labelText={displayPropMapping[key].label}
                            labelValue={memberPortalData.portalShortNm === 'MYUHC' && key === 'MemberId' ? memberPortalData[displayPropMapping['SubscriberId'].fieldName] : memberPortalData[displayPropMapping[key].fieldName]}
                            labelWidth="40%"/>
                    );
                    displayValue = props.updatedFormData[key];
                    if(props.modifyEligPortal.portalShortNm === "CAP" && key === "SubscriberId") {
                        displayValue = props.faroId;
                    }
                    if(props.modifyEligPortal.portalShortNm === 'MYUHC' && key === 'MemberId'){
                        displayValue = props.updatedFormData['SubscriberId']
                    }
                    newPortalEligElems.push(
                        <Label
                            key={"new"+displayPropMapping[key].label}
                            displayType="horizontal"
                            labelText={displayPropMapping[key].label}
                            labelValue={displayValue}
                            labelWidth="40%"/>
                    );

                    if(!changeInData){
                        if(memberPortalData.portalShortNm === 'MYUHC' && key === 'MemberId'){
                            changeInData = memberPortalData[displayPropMapping['SubscriberId'].fieldName] !== props.updatedFormData['SubscriberId'] ? true : false;
                        }else {
                            changeInData = memberPortalData[displayPropMapping[key].fieldName] !== props.updatedFormData[key] ? true : false;
                        }
                    }
                    objKey = key;
                    objValue =  memberPortalData[displayPropMapping[key].fieldName];
                    prevInfoObject = {
                        ...prevInfoObject,
                        [objKey]:  objValue
                    }
                }
            }
        }else{
            for (let key in props.updatedFormData) {
                if(displayPropMapping[key])
                {
                    currentPortalEligElems.push(
                        <Label
                            key={"curr"+displayPropMapping[key].label}
                            displayType="horizontal"
                            labelText={memberPortalData.portalShortNm === 'ECONSENTLOOP' && key === 'memberId' ?MEDICAL_RECORD_NUMBER:displayPropMapping[key].label}
                            labelValue={memberPortalData.portalShortNm === 'MYUHC' && key === 'MemberId' ? memberPortalData[displayPropMapping['SubscriberId'].fieldName] : memberPortalData[displayPropMapping[key].fieldName]}
                            labelWidth="40%"/>
                    );
                    displayValue = props.updatedFormData[key];
                    newPortalEligElems.push(
                        <Label
                            key={"new"+displayPropMapping[key].label}
                            displayType="horizontal"
                            labelText={memberPortalData.portalShortNm === 'ECONSENTLOOP' && key === 'memberId' ?MEDICAL_RECORD_NUMBER:displayPropMapping[key].label}
                            labelValue={displayValue}
                            labelWidth="40%"/>
                    );
                    if(!changeInData){
                        if(memberPortalData.portalShortNm === 'MYUHC' && key === 'MemberId'){
                            changeInData = memberPortalData[displayPropMapping['SubscriberId'].fieldName] !== props.updatedFormData['SubscriberId'] ? true : false;
                        }else {
                            changeInData = memberPortalData[displayPropMapping[key].fieldName] !== props.updatedFormData[key] ? true : false;
                        }
                    }
                }
            }
        }
        const currentPortalElig = memberPortalData?(
            <div className={classes.Section}>
                <strong className={classes.SectionTitle}>
                    Current {getPortalNameForEligibilityScreen(props.modifyEligPortal.portalShortNm, props.portals)} 
                    {props.modifyEligPortal?.portalShortNm === CAREADVISORCONNECT?" Details": " Portal Details"}
                </strong>
                {currentPortalEligElems}
            </div>
        ):null;

        const newPortalElig = (
            <div className={classes.Section}>
                <strong className={classes.SectionTitle}>
                    New {getPortalNameForEligibilityScreen(props.modifyEligPortal.portalShortNm, props.portals)} 
                    {props.modifyEligPortal?.portalShortNm === CAREADVISORCONNECT?" Details": " Portal Details"}
                </strong>
                {newPortalEligElems}
            </div>
        );

        const buttons = (
            <div className={classes.ButtonDiv}>
                <Button id="cancel" btnType="Cancel" clicked={props.cancelled}>Cancel</Button>
                <Button id="save" btnType="AddAccountSearch" clicked={() => props.updateEligibility(props.updatedFormData, memberPortalData.memberPortalId, prevInfoObject)}>{LABEL_SAVE}</Button>
            </div>
        );

        form = changeInData?
            <Fragment>
                {memberMdmInfo}
                <br/>
                <div className={classes.EligSection}>
                    {currentPortalElig}
                    {newPortalElig}
                </div>
                <br/>
                {buttons}
            </Fragment>:
            <Fragment>
                <p className={classes.Caution}>No change in data! Pls make changes before updating.</p>
                <p><Button id="close" btnType="Cancel" clicked={props.cancelled}>Close</Button></p>
            </Fragment>;
    }

    return form;
}

export default modifyEligibilityConfirmation;